import { DSResource, DSNCFaq } from 'shared-definitions/types'
import { ApiComponent, ApiComponentAdpFaqs } from '../types.wp'
import { PLinkMapperOpts } from './pLinkMapper'

interface AdpFaqsOpts<T extends DSResource, A extends ApiComponent> extends PLinkMapperOpts {
  componentItemMapper: (input: A) => T | T[]
}
export function ncAdpFaqs<T extends DSResource, A extends ApiComponent>(
  input: ApiComponentAdpFaqs<A>,
  opts: AdpFaqsOpts<T, A>
): DSNCFaq<T>[] {
  return input.faqs.flatMap(faq => {
    if (!faq) {
      return []
    }
    return {
      icon: null,
      resource: 'nc-faq',
      question: faq.question,
      image: null,
      blocks: faq.content.flatMap(opts.componentItemMapper),
      analytics: {
        endpoint: input.api_url,
        entity: {
          id: faq.id.toString(),
          type: faq.entity_type,
        },
      },
      evaluateBlock: {
        title: 'Was this helpful',
      },
    }
  })
}
